import { date } from 'quasar'
import { distanceInWords } from 'src/utils/date'
import { formatMoney } from 'src/utils/format'
import i18n from 'src/i18n/i18n'
import parseDate from 'date-fns/parse'
import { quotes as quotesConfig } from 'src/config'

const columns = [
  { name: 'quote_number', required: true, label: i18n.t('quote_number'), align: 'left', field: 'quote_number', sortable: true },
  { name: 'total_gross', required: true, label: i18n.t('sum_gross'), align: 'left', field: 'total_gross' },
  { name: 'created_at', required: true, label: i18n.t('created_at'), align: 'left', field: 'created_at', sortable: true },
  { name: 'status', required: true, label: i18n.t('status'), align: 'left', field: 'status' },
  { name: 'valid_until', required: true, label: i18n.t('valid_until'), align: 'left', field: 'valid_until' },
  { name: 'actions', required: false, label: '', align: 'right', field: 'quote_number' }
]

const mapFunction = quotes => {
  return quotes.map(quote => {
    return {
      ...quote,
      'total_gross': formatMoney(quote.total_gross, quote.currency),
      'valid_until': date.formatDate(parseDate(quote.valid_until.date), i18n.t('date_format')),
      'status': { value: quote.status, color: quotesConfig.status_colors[quote.status] },
      'created_at': distanceInWords(quote.created_at.date)
    }
  })
}

export { mapFunction, columns }
